<template>
    <form id="formEditBid" class="wrapper wrapper-content">
        <div class="row">
            <div class="col-lg-8 col-md-10 col-sm-12">
                <div class="mail-box-header">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <h4>Status:</h4>
                                <div class="flex-row">
                                    <div class="status BulletStatus" :class="bid.status_code"></div>
                                    <span style="margin-left: 10px">{{ bid.status_description }}</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <h4>Área de atuação:</h4>
                                <input class="form-control"
                                       type="text"
                                       :value="bid.field.name"
                                       disabled
                                />
                            </div>
                            <div class="form-group">
                                <h4>Localidade:</h4>
                                <input type="text"
                                       class="form-control"
                                       :value="bid.location.name + ' - ' + bid.location.state.name"
                                       disabled
                                >
                            </div>
                            <div class="form-group">
                                <h4>Pode ser feito remotamente:</h4>
                                <span>{{ bid.can_be_done_remotely == 1 ? "Sim" : "Não" }}</span>
                            </div>
                            <div class="form-group">     
                                <attachment :attachments="bid_attachments" :is_bid="true" :show_options="true" :id="bid.id" :path="'bid_attachments'"></attachment>
                            </div>  
                            <div class="form-group">
                                <input class="form-control" id='bid_docs_input' v-on:change="handleAttachments" multiple accept=".pdf,.txt,.doc,.docx,.odt" type="file" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <h4>Descrição:</h4>
                                <textarea class="form-control"
                                          name="description"
                                          cols="30"
                                          rows="5"
                                          v-model="form.description"
                                ></textarea>
                            </div>
                            <!--div class="form-group">
                                <label for="bid_estimated_value" class="control-label">
                                    Valor Estimado:
                                </label>
                                <select class="form-control"
                                       type="date"
                                       id="bid_estimated_value"
                                       v-model="form.bid_estimated_value">
                                        <option value="R$ 100,00 a R$ 500,00">R$ 100,00 a R$ 500,00</option>
                                        <option value="R$ 500,00 a R$ 1.500,00">R$ 500,00 a R$ 1.500,00</option>
                                        <option value="R$ 1.500,00 a R$ 3.000,00">R$ 1.500,00 a R$ 3.000,00</option>
                                        <option value="R$ 3.000,00 a R$ 5.000,00">R$ 3.000,00 a R$ 5.000,00</option>
                                        <option value="R$ 5.000,00 a R$ 7.000,00">R$ 5.000,00 a R$ 7.000,00</option>
                                        <option value="Acima de R$ 7.000,00">Acima de R$ 7.000,00</option>
                                </select>
                            </div-->
                            <!--div class="form-group">
                                <label for="bid_complexity" class="control-label">
                                    Complexidade:
                                </label>
                                <select class="form-control"
                                       type="date"
                                       id="bid_complexity"
                                       v-model="form.bid_complexity">
                                        <option>Selecione</option>
                                        <option value="Baixo">Baixo</option>
                                        <option value="Médio">Médio</option>
                                        <option value="Alto">Alto</option>
                                </select> 
                            </div-->
                            <div class="form-group">
                                <h4>Data Publicação:</h4>
                                <input type="date"
                                       class="form-control"
                                       :value="form.created_at|moment('Y-MM-DD')"
                                       disabled
                                >
                            </div>
                            <div class="form-group"
                                 :class="{ 'has-error': form.errors.has('expires_at') }"
                            >
                                <label for="expires_at" class="control-label">
                                    Data limite para os orçamentos:
                                </label>
                                <input class="form-control"
                                       type="date"
                                       id="expires_at"
                                       v-model="form.expires_at"
                                >
                                <span class="help-block" v-if="form.errors.has('expires_at')">
                                    {{ form.errors.first('expires_at') }}
                                </span>
                            </div>
                            <div class="form-group"
                                 :class="{ 'has-error': form.errors.has('bid_conclusion_date') }"
                                >
                                <label for="bid_conclusion_date" class="control-label">
                                    Data Limite de Conclusão da Pericia:
                                </label>
                                <input class="form-control"
                                       type="date"
                                       id="bid_conclusion_date"
                                       v-model="form.bid_conclusion_date"
                                >
                                <span class="help-block" v-if="form.errors.has('bid_conclusion_date')">
                                    {{ form.errors.first('bid_conclusion_date') }}
                                </span>
                            </div>
                            <div class="form-group">
                                <label for="inspection_needed" class="control-label">
                                    Necessidade de vistoria presencial:
                                </label>
                                <select class="form-control"
                                       type="date"
                                       id="inspection_needed"
                                       v-model="form.inspection_needed">
                                        <option value="0">Não</option>
                                        <option value="1">Sim</option> 
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="expert_skills_needed" class="control-label">
                                    Certificações exigidas do Perito Assistente 
                                    <a class="fa fa-info-circle como-funciona-descricao" href="#">
                                        <span class="tooltips" style='color: #337ab7; font-family:"open sans", "Helvetica Neue", Helvetica, Arial, sans-serif; font-size:13px;'>Por exemplo: CRECI, CREA, CRM, etc.</span>
                                    </a>
                                </label>
                                <select class="form-control"
                                        type="text"
                                        id="expert_skills_needed_base"
                                        placeholder="CRECI e CREA"
                                        v-model="expert_skills_needed_base">
                                        <option>Selecione</option>
                                        <option value="Nenhuma">Nenhuma</option>
                                        <option value="CREA">CREA</option>
                                        <option value="CRECI">CRECI</option>
                                        <option value="CRB">CRB</option>
                                        <option value="CRC">CRC</option>
                                        <option value="CRM">CRM</option>
                                        <option value="CRO">CRO</option>
                                        <option value="CRP">CRP</option>
                                        <option value="CREFITO">CREFITO</option>
                                        <option value="CRF">CRF</option>
                                        <option value="COREN">COREN</option>
                                        <option value="OAB">OAB</option>
                                        <option value="Outros">Outros</option>
                                </select>
                                <input  v-if="expert_skills_needed_base == 'Outros'"
                                        class="form-control"
                                        type="text"
                                        id="expert_skills_needed_others"
                                        placeholder="Descreva a certificação necessária"
                                        v-model="expert_skills_needed_others"> 
                                </input>
                            </div>
                            <div class="form-group first">
                                <label for="bid_type">A sua demanda é</label>
                                <select name="bid_type"
                                id="bid_type"
                                class="form-control"
                                v-model="form.bid_type"
                                >
                                    <option value="judicial">Judicial</option>
                                    <option value="extrajudicial">Extrajudicial</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="bid_side">A sua demanda é do lado do(a)</label>
                                <select name="bid_side"
                                id="bid_side"
                                class="form-control"
                                v-model="form.bid_side"
                                >
                                    <option value="empresa">Empresa</option>
                                    <option value="empregado">Empregado/Ex-Empregado</option>
                                    <option value="pessoafisica">Pessoa Física</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="bid_opener">Quem abriu a demanda é</label>
                                <select name="bid_opener"
                                        id="bid_opener"
                                        class="form-control"
                                        v-model="form.bid_opener">
                                    <option value="escritorio_advocacia">Escritório de Advocacia</option>
                                    <option value="advogado_autonomo">Advogado Autônomo</option>
                                    <option value="rh_empresa">RH da empresa</option>
                                    <option value="financeiro_empresa">Financeiro da empresa</option>
                                    <option value="autor_reu_do_processo">Autor/réu do processo</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="text-right hidden-md-down" v-if="canBeSaved">
                                <button class="btn btn-lg btn-primary"
                                        type="button"
                                        @click="onUpdate"
                                >
                                    <i class="fa fa-edit"></i> Atualizar dados
                                </button>
                            </p>
                            <p class="text-center hidden-md-up" v-if="canBeSaved">
                                <button class="btn btn-lg btn-primary"
                                        type="button"
                                        @click="onUpdate"
                                >
                                    <i class="fa fa-edit"></i> Atualizar dados
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="mail-box">
                    <div class="mail">
                        <div class="row">
                            <!-- <div class="col-md-12">
                                <h2>Status da Negociação</h2>
                                <bid-status :bid="bid" :contractor="true" :show_title="true"></bid-status>
                            </div> -->
                            <div class="col-md-12">
                                <h2>Inscrições</h2>
                                <table class="table table-hover table-mail">
                                    <thead>
                                        <tr>
                                            <td><strong>Perito</strong></td>
                                            <td><strong>E-mail</strong></td>
                                            <td><strong>Telefone</strong></td>
                                            <td><strong>Especializações</strong></td>
                                            <td><strong>Ações</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="subscription in bid.active_subscriptions"
                                            :key="subscription.id"
                                        >
                                            <template v-if="subscription.expert.user!=null">
                                                <td>{{ subscription.expert.user.full_name }}
                                                <td>{{ subscription.expert.user.email }}
                                                <td>{{ subscription.expert.user.profile.mobile_phone }}
                                                <td>
                                                    {{ subscription.expert.skills.join(', ') }}
                                                </td>
                                                <td>
                                                    <a :href="'/perfil_perito/' + subscription.expert.user_id"
                                                        class="btn btn-xs btn-default"
                                                    >
                                                        ver perfil
                                                    </a>
                                                    <a :href="'/chats/' + subscription.id"
                                                        class="btn btn-xs btn-primary hidden-md-up" style="margin-top:5px"
                                                    >
                                                        abrir chat
                                                    </a>
                                                    <a :href="'/chats/' + subscription.id"
                                                    class="btn btn-xs btn-primary hidden-md-down-inline"
                                                    >
                                                        abrir chat
                                                    </a>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row hidden-md-down">
                            <div class="col-md-6 text-left">
                                <strong>Inscritos:</strong>
                                <span>{{ bid.active_subscriptions.length }}</span>
                            </div>
                            <div class="col-md-6 text-right" v-if="bid.is_active">
                                <strong>{{ expiresText }}</strong>
                                <span>{{ bid.expires_at|moment('from') }}</span>
                            </div>
                        </div>
                        <div class="row hidden-md-up">
                            <div class="col-md-6 text-center">
                                <strong>Inscritos:</strong>
                                <span>{{ bid.active_subscriptions.length }}</span>
                            </div>
                            <div class="col-md-6 text-center" v-if="bid.is_active">
                                <strong>{{ expiresText }}</strong>
                                <span>{{ bid.expires_at|moment('from') }}</span>
                            </div>
                        </div>

                        <button class="btn btn-primary"
                                type="button"
                                onclick="openModal('aviso-de-demanda')"
                                v-if="!bid.is_full"
                        >
                            
                            <i class="fa fa-envelope"></i> Enviar aviso de demanda
                        </button>

                    </div>
                    <div class="mail-body text-right hidden-md-down">
                        <button onclick="openModal('excluir-demanda')"
                                class="btn btn-lg btn-danger"
                                style="float: left;"
                                type="button" 
                                v-if="bid.active_subscriptions.length == 0"
                        >
                            <i class="fa fa-window-close"></i> Excluir Demanda
                        </button>
                        <button onclick="openModal('finalizar-demanda')"
                                class="btn btn-lg btn-gray"
                                type="button"
                                v-if="bid.is_active"
                        >
                            <i class="fa fa-window-close"></i> Finalizar Demanda
                        </button>


                        <button class="btn btn-lg btn-primary"
                                type="button"
                                onclick="openModal('reabrir-demanda')"
                                v-if="bid.is_full"
                        >
                            Reabrir Demanda
                        </button>
                    </div>
                    <div class="mail-body text-center hidden-md-up">
                        <button onclick="openModal('finalizar-demanda')"
                                class="btn btn-lg btn-gray"
                                type="button"
                                v-if="bid.is_active"
                        >
                            <i class="fa fa-window-close"></i> Finalizar Demanda
                        </button>

                        <button onclick="openModal('excluir-demanda')"
                                class="btn btn-lg btn-danger"
                                type="button"
                                style="margin-top: 40px;" 
                                v-if="bid.active_subscriptions.length == 0"
                        >
                            <i class="fa fa-window-close"></i> Excluir Demanda
                        </button>

                        <button class="btn btn-lg btn-primary"
                                type="button"
                                onclick="openModal('reabrir-demanda')"
                                v-if="bid.is_full"
                        >
                            Reabrir Demanda
                        </button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import moment from 'moment';
import Form from 'form-backend-validation';

export default {
    props: {
        bid: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: new Form({
                ...this.bid,
                expires_at: moment(this.bid.expires_at).format('Y-MM-DD'),
                bid_conclusion_date: this.bid.bid_conclusion_date ? moment(this.bid.bid_conclusion_date).format('Y-MM-DD') : null,
            }),
            expiresText:null,
            bid_type:null,
            bid_side:null,
            bid_attachments: this.bid.bid_attachments,
            bid_conclusion_date_flag: 0,
            expert_skills_needed_base: '',
            expert_skills_needed_others: ''
        };
    },
    mounted() {
        // console.log(this.bid.expires_at);
        // console.log(this.bid.bid_type);
        // console.log(this.bid.bid_side);
        // console.log(this.bid.bid_side_formatted);
        // console.log(this.bid.bid_type_formatted);

        var experiredAt = new Date(this.bid.expires_at);
        var nowDate = new Date();

        if(experiredAt > nowDate){
            this.expiresText = 'Demanda irá expirar ';
        } else {
            this.expiresText = 'Demanda expirada ';
        }
        
        if(this.bid.expert_skills_needed)
            if(Array.from(document.getElementById("expert_skills_needed_base").options).map((opt) => opt.value).includes(this.bid.expert_skills_needed))
                this.expert_skills_needed_base = this.bid.expert_skills_needed;
            else{

                this.expert_skills_needed_base = 'Outros';
                this.expert_skills_needed_others = this.bid.expert_skills_needed;
            
            }

    },
    computed: {
        canBeSaved() {
            return !this.bid.is_expired && !this.bid.is_closed;
        },
    },
    methods: {
        load(bid) {
            this.form = new Form({
                ...bid,
                expires_at: moment(bid.expires_at).format('Y-MM-DD'),
                bid_conclusion_date: bid.bid_conclusion_date ? moment(bid.bid_conclusion_date).format('Y-MM-DD') : null,
            })
        },
        handleAttachments(e) {  

            this.bid_docs = e.target.files;
            
        },
        onUpdate() {
             
            if(this.bid_docs != null){

                let config = {
                    headers: { 
                        'content-type': 'multipart/form-data' 
                    }
                };

                let formData = new FormData();

                let filesQtt = this.bid_docs.length; 

                for (let x = 0; x < filesQtt; x++) {
                    formData.append("bid_docs[]", this.bid_docs[x]);
                } 

                formData.append('id', this.bid.id);

                axios.post('/demandas/attachment', formData, config)
                    .then((response) =>  {

                        $('#bid_docs_input').val('');
                        this.bid_docs = null;
                        this.bid_attachments = response.data;

                        toastr.success('Anexo salvo com sucesso');
                    })
                    .catch((err) => {
                        toastr.error('Erro ao salvar anexo');
                    });

            }
            
            this.form.expert_skills_needed = this.expert_skills_needed_base != 'Outros' ? this.expert_skills_needed_base : this.expert_skills_needed_others;

            this.form.patch(`/admin/demanda/${this.bid.id}`)
                .then((response) =>  {
                    this.load(response);
                    toastr.success('Demanda atualizada com sucesso');
                })
                .catch((err) => {
                    toastr.error('Erro ao atualizar a demanda');
                });
        },
    }
}
</script>
